// extracted by mini-css-extract-plugin
export default {"formGroup":"AddOrEditModal_formGroup__taUU9","label":"AddOrEditModal_label__kOShz"};